import React, { Dispatch, SetStateAction, useContext } from 'react';
import { TimeslotFilterMenuViewProps } from '../TimeslotFilterMenu/TimeslotFilterMenu.view';
import { TimeslotFilterMenu } from '../TimeslotFilterMenu';
import { ContainerListItem } from '../../../../components/actions/ListItem/ListItem.view';
import { ButtonMenu } from '../../../../components/actions/ButtonMenu';
import { IconsEnum } from '../../../../constants/icons';
import { Button } from '../../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import classes from './ThirdLevelNavigation.module.scss';
import classNames from 'classnames';
import { Void } from '../../../../models/basic-objects';
import { FilterDropdown } from '../../../../components/containers/FilterDropdown';
import { useBreakpoints } from '../../../../hooks/useBreakpoints';
import { BoxNotification } from '../../../../components/containers/BoxNotification';
import { Icon } from '../../../../components/images/Icon/Icon';
import { Tooltip } from '../../../../components/actions/Tooltip';
import { Link } from 'react-router-dom';
import { ContainerListItemExtended } from '../../../../components/actions/ButtonMenu/ButtonMenu.view';
import { OnboardingContext } from '../../../Onboarding/states/OnboardingProvider';
import { OnboardingStaticContent } from '../../../Onboarding/constants/content';

export type ThirdNavLeftPostingPlanProps = TimeslotFilterMenuViewProps & {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isQueuePaused: boolean;
};

const QueuePausedAlert = () => {
  return (
    <>
      <Tooltip pointer type={'regular'} target={`#unqueueWarning`} autoHide={false}>
        <>
          No posts will be published until you <Link to={'/settings/pause'}>unpause your Queue.</Link>
        </>
      </Tooltip>
      <div id={'unqueueWarning'} className={classes.RedAlertContainer}>
        <Icon name={IconsEnum.triangleWarning} size={'medium'} />
      </div>
    </>
  );
};
export const ThirdNavLeftButtons = (props: ThirdNavLeftPostingPlanProps): JSX.Element => {
  const filterMenu = (
    <TimeslotFilterMenu
      filters={props.filters}
      profiles={props.profiles}
      categories={props.categories}
      dispatchFilters={props.dispatchFilters}
      formInstance={props.formInstance}
      timeslots={props.timeslots}
      profilesFilteredTimeslots={props.profilesFilteredTimeslots}
      categoriesFilteredTimeslots={props.categoriesFilteredTimeslots}
      loading={props.loading}
      isDropdown={true}
    />
  );
  const breakpoint = useBreakpoints();
  const showQueuePausedAlert = !(breakpoint === 'xlarge' || breakpoint === 'xxlarge') && props.isQueuePaused;
  return (
    <>
      <div className={'show-for-small-only flex-container'}>
        <Button
          type={'button'}
          variant={'hollow'}
          size={'medium'}
          color={ButtonColorsEnum.primary}
          icon={{
            side: 'left',
            value: IconsEnum.filter
          }}
          action={() => props.setOpen(true)}>
          Filters
        </Button>
        {showQueuePausedAlert && <QueuePausedAlert />}
      </div>
      <div className={'grix-x'}>
        <div className={'flex-container relative'}>
          <FilterDropdown>{filterMenu}</FilterDropdown>
          <div className={'hide-for-small-only'}>{showQueuePausedAlert && <QueuePausedAlert />}</div>
        </div>
      </div>
    </>
  );
};

export type ThirdNavRightPostingPlanProps = {
  addTimeslotHandler: Void;
  setOpenBulkDeleteTimeslotsModal: Dispatch<SetStateAction<boolean>>;
};

export const ThirdNavCenterContent = ({ isQueuePaused }: { isQueuePaused: boolean }) => {
  const breakpoint = useBreakpoints();
  const shouldShowText = breakpoint === 'xlarge' || breakpoint === 'xxlarge';
  if (shouldShowText && isQueuePaused) {
    return (
      <BoxNotification customClassNames={classes.CustomBox} type={'error'}>
        <span>
          No posts will be published until you <Link to={'/settings/pause'}>unpause your Queue.</Link>
        </span>
      </BoxNotification>
    );
  }
  return <></>;
};
export const ThirdNavRightButtons = (props: ThirdNavRightPostingPlanProps): JSX.Element => {
  const { showOnboarding, state: onboardingState } = useContext(OnboardingContext);
  const { version } = onboardingState;
  const disableDelete = OnboardingStaticContent[`v${version}`].disableDelete.posts;

  const ButtonMenuListItems: Array<ContainerListItem | ContainerListItemExtended> = [
    {
      action: () => props.setOpenBulkDeleteTimeslotsModal(true),
      label: 'Bulk Delete',
      ...(showOnboarding && disableDelete
        ? { disabled: true, disabledTooltipText: 'You will be able to delete these demo posts later.' }
        : {})
    }
  ];

  const buttonWrapperClasses = classNames(classes.ButtonWrapper, 'cell', 'shrink');

  return (
    <div className={'grid-x align-right'}>
      <div className={buttonWrapperClasses}>
        <ButtonMenu
          isSquareButton={false}
          elementType={'button'}
          variant={'hollow'}
          listItems={ButtonMenuListItems}
          side={'right'}
          size={'medium'}
          icon={IconsEnum.threeDot}
        />
      </div>
      <div className={'hide-for-small-only cell shrink'}>
        <Button
          type={'button'}
          variant={'solid'}
          size={'medium'}
          color={ButtonColorsEnum.primary}
          icon={{ side: 'left', value: IconsEnum.plus }}
          action={() => props.addTimeslotHandler()}>
          Add Timeslot
        </Button>
      </div>
      <div className={'show-for-small-only cell shrink'}>
        <Button
          type={'button'}
          variant={'solid'}
          size={'medium'}
          color={ButtonColorsEnum.primary}
          icon={{ side: 'center', value: IconsEnum.plus }}
          action={() => props.addTimeslotHandler()}
        />
      </div>
    </div>
  );
};
